<template>
  <div class="row">

    <transition name="el-fade-in-linear" mode="out-in">

      <div key="View" v-if="verificationId">
        <verification-view :id="verificationId" :inner="true" :result="result" />
        <div class="col-md-12 card card-plain">
          <button @click.prevent="verificationId = null; result = null; getHistory()" type="button" class="btn btn-wd btn-fill btn-move-left"><span class="btn-label"><i class="ti-angle-left"></i></span> Back</button>
        </div>
      </div>
      
      <div key="Pending" v-else class="col-md-12 card">
        <div class="card-header">
          <h4 class="card-title">Pending Verifications</h4>
          <div class="category">Verifications to be resolved by you and your team</div>
        </div>
        <div class="card-content row form-horizontal">
          <div class="filters form-group" style="margin-left: 0">
            <transition name="el-fade-in-linear" mode="out-in">
              <div key="filtersClose" v-if="!filtersOpen">
                <div class="col-sm-10">
                  <el-input placeholder="Quick Search" prefix-icon="el-icon-search" v-model="query" style="width: 100% !important"></el-input>
                </div>
                <div class="col-sm-2">
                  <button @click.prevent="filtersOpen = true" class="btn btn-fill btn-default"><i class="fa fa-filter"></i>&nbsp;Filters {{filtersCount}}</button>
                </div>
              </div>
              <div key="filtersOpen" v-else="filtersOpen" class="col-sm-12 card-plain">
                <div class="el-collapse">
                  <div class="el-collapse-item is-active">
                    <div role="tab" style="margin-bottom: 15px">
                      <div @click="filtersOpen= false" role="button" class="el-collapse-item__header pull-right">
                        <i class="fa fa-times pull-right"></i>
                      </div>
                    </div>
                    <div role="tabpanel" class="el-collapse-item__wrap">
                      <div class="el-collapse-item__content"> 
                        <div class="form-horizontal">
                          <div class="form-group">
                            <label class="col-sm-2 control-label">Name or QCID</label>
                            <div class="col-sm-10">
                              <el-input placeholder="All" prefix-icon="el-icon-search" v-model="query" :clearable="true"></el-input>
                              <span class="help-block">Search by first, last or full name, or by QCID.</span>
                            </div>
                          </div>

                          <div class="form-group">
                            <label class="col-sm-2 control-label">Date</label>
                            <div class="col-sm-10">
                              <el-date-picker
                                v-model="dateRange"
                                type="daterange"
                                size="large"
                                :editable="false"
                                start-placeholder="Start date"
                                end-placeholder="End date"
                                value-format="yyyy-MM-dd"
                                :picker-options="pickerOptions">
                              </el-date-picker>
                              <span class="help-block">Show only verifications on or between these dates.</span>
                            </div>
                          </div>

                          <div class="form-group">
                            <label class="col-sm-2 control-label"></label>
                            <div class="col-sm-10">
                              <button @click.prevent="clearFilters" class="btn btn-default btn-fill btn-wd">Clear All</button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </transition>
          </div>
          <div class="col-sm-12">
            <el-table class="table table-striped table-no-bordered table-hover"
                      ref="historyTable"
                      :data="history"
                      v-loading="paging"
                      element-loading-spinner="qc-spinner"
                      style="width: 100%"
                      :row-class-name="rowClass"
                      highlight-current-row
                      @current-change="showVerification"
                      tooltip-effect="light">
              <el-table-column :min-width="80" label="Date">
                <template slot-scope="props">
                  <span>{{formatDate(props.row.recorded)}}</span>
                </template>
              </el-table-column>
              <el-table-column :min-width="180" :show-overflow-tooltip="true" label="Name">
                <template slot-scope="props">
                  <span>{{props.row.fields.firstname}} {{props.row.fields.surname}}</span>
                </template>
              </el-table-column>
              <el-table-column :min-width="180" :show-overflow-tooltip="true" label="Institute">
                <template slot-scope="props">
                  <span>{{props.row.instituteName}}</span>
                </template>
              </el-table-column>
              <el-table-column :min-width="120" :show-overflow-tooltip="true" label="Verifying Organisation">
                <template slot-scope="props">
                  <span>{{props.row.company ? props.row.company : props.row.institute}}</span>
                </template>
              </el-table-column>
              <el-table-column
                :min-width="100"
                fixed="right"
                align="center"
                label="Status">
                <template slot-scope="props">
                  <span v-if="props.row.result == 'VERIFIED'" class="label label-wd label-plain"><i class="fa fa-check"></i>Verified</span>
                  <span v-else-if="props.row.result == 'NOT_VERIFIED'" class="label label-wd label-plain"><i class="fa fa-times"></i>Not Verified</span>
                  <span v-else-if="props.row.result == 'PENDING'" class="label label-wd label-plain"><i class="fa fa-clock-o"></i>Pending</span>
                  <span v-else-if="props.row.result == 'REJECTED'" class="label label-wd label-danger"><i class="fa fa-exclamation"></i>Action Required!</span>
                  <span v-else-if="props.row.result == 'NOT_FOUND'" class="label label-wd label-danger"><i class="fa fa-exclamation"></i>Action Required!</span>
                  <span v-else-if="props.row.result == 'UNPAID'" class="label label-wd label-warning"><i class="fa fa-pencil"></i>Incomplete</span>
                  <span v-else-if="props.row.result == 'AWAITING_CONSENT'" class="label label-wd label-warning"><i class="fa fa-pencil"></i>Incomplete</span>
                  <span v-else-if="props.row.result == 'CANCELLED'" class="label label-wd label-plain"><i class="fa fa-times"></i>Cancelled</span>
                  <span v-else-if="props.row.result == 'UNABLE'" class="label label-wd label-plain"><i class="fa fa-clock-o"></i>Delayed at Source</span>
                  <span v-else>{{props.row.result}}</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="col-sm-6 pagination-info">
            <p class="category">Showing {{from + 1}} to {{to}} of {{total}} entries</p>
          </div>
          <div class="col-sm-6">
            <p-pagination class="pull-right"
                          v-model="pagination.currentPage"
                          :per-page="pagination.perPage"
                          :total="pagination.total">
            </p-pagination>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
  import View from 'src/views/Verifications/View'

  import {DatePicker} from 'element-ui'

  import PPagination from 'src/components/Pagination.vue'

  import moment from 'moment'
  import _ from 'lodash'

  export default {
    name: "pending-history",
    components: {
      [DatePicker.name]: DatePicker,
      PPagination,
      'verification-view': View
    },
    data () {
      return {
        verificationId: null,
        result: null,
        highlight: null,
        invoiceId: null,
        history: null,
        paging: false,
        total: 0,
        pagination: {
          perPage: 20,
          currentPage: 1,
          perPageOptions: [5, 10, 25, 50],
          total: 0
        },
        query: null,
        internalResults: [],
        dateRange: [],
        filtersOpen: false,
        pickerOptions: {
          shortcuts: [
            {
              text: 'Last week',
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                picker.$emit('pick', [start, end]);
              }
            }, {
              text: 'Last month',
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                picker.$emit('pick', [start, end]);
              }
            }, {
              text: 'Last 3 months',
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                picker.$emit('pick', [start, end]);
              }
            }
          ]
        }
      }
    },
    mounted () {
      this.getHistory()
    },
    activated () {
      this.getHistory()
    },
    watch: {
      query: _.debounce(function  (value) {
        this.pagination.currentPage = 1
        this.getHistory()
      }, 500),
      dateRange (value) {
        this.getHistory()
      },
      paginationCurrentPage (value) {
        this.getHistory()
      },
      paginationPerPag (value) {
        this.getHistory()
      }
    },
    computed: {
      filtersCount () {
        var count = 0
        if(this.query) count++
        if(this.dateRange.length > 0) count++
        return count > 0 ? "(" + count + ")" : ""
      },
      paginationCurrentPage () {
        return this.pagination.currentPage
      },
      paginationPerPag () {
        return this.pagination.perPage
      },
      to () {
        let highBound = this.from + this.pagination.perPage
        if (this.total < highBound) {
          highBound = this.total
        }
        return highBound
      },
      from () {
        return this.pagination.perPage * (this.pagination.currentPage - 1)
      }
    },
    methods: {
      filtersChange (activeNames) {
        var _this = this;
        setTimeout(function () {
          _this.filtersOpen = activeNames.includes("open")
        }, 0);
      },
      clearResults () {
        this.results = []
        this.internalResults = []
        this.$store.commit('setHistoryFilters', {results: []})
      },
      clearFilters () {
        this.query = null
        this.results = []
        this.internalResults = []
        this.dateRange = []
        this.$store.commit('clearHistoryFilters', null)
      },
      rowClass(row) {
        if(this.highlight && this.highlight.includes("" + row.row.id)) {
          return 'danger-row'
        }
      },
      formatDate (timestamp) {
        var m = moment(timestamp)
        return m.format('DD MMM YYYY')
      },
      getHistory () {
        this.paging = true
        this.history = []
        let historyRequest = {
          page: this.pagination.currentPage - 1,
          query: this.query,
          fromDate: this.dateRange[0],
          toDate: this.dateRange[1]
        }
        this.$api.getPendingVerifications(historyRequest)
          .then(response => {
            this.history = response.data.content
            this.pagination.total = response.data.totalSize
            this.total = response.data.totalSize
            this.paging = false
          })
          .catch(error => {
            this.paging = false
          })
      },
      showVerification (row, oldRow) {
        // this.verificationId = '' + row.id
        // this.result = row.result
        if(row) {
          this.$router.push('/verification/pending/' + row.id)
        }
      }
    }
  }
</script>
<style>

</style>
